import React from 'react';

export enum Direction {
  Ascending = 'ascending',
  Descending = 'descending'
}

export interface IConfig {
  key: string;
  direction: Direction
}

export const useSortableItems = (items:Array<any> | null, config:IConfig | null = null) => {
  const [ sortConfig, setSortConfig ] = React.useState<IConfig | null>(config);

  const sortedItems = React.useMemo(() => {
    if ( !items ) return [];
    let sortableItems = [...items];
    if ( sortConfig !== null ) {
      sortableItems.sort((a, b) => {
        const getValue = (item:any) => {
          if (!item || item[sortConfig.key] == null) return null;
          return Array.isArray(item[sortConfig.key]) ? item[sortConfig.key][0] : item[sortConfig.key];
        };
  
        const aItem = getValue(a);
        const bItem = getValue(b);
  
        if (aItem === null && bItem === null) return 0;
        if (aItem === null) return 1;
        if (bItem === null) return -1;
  
        if (aItem < bItem) return sortConfig.direction === Direction.Ascending ? -1 : 1;
        if (aItem > bItem) return sortConfig.direction === Direction.Ascending ? 1 : -1;
        return 0;
      });
    }
  
    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = (key:string, direction?:Direction) => {
    if ( !direction ){
      direction = Direction.Ascending;
      if ( sortConfig && sortConfig.key === key && sortConfig.direction === Direction.Ascending ){
        direction = Direction.Descending;
      }
      setSortConfig({ key, direction });
    } else {
      setSortConfig({ key, direction });
    }
  }

  const getClassNamesFor = (key:string) => {
    if ( !sortConfig ) return;
    return sortConfig.key === key ? `sort-${sortConfig.direction}` : undefined;
  };

  return {
    items: sortedItems,
    sortConfig,
    requestSort,
    getClassNamesFor,
  };
}